import instance from '../instace';

export const createDynAccount = async (name:string,token:string) => {
    try {
      const get: any = await instance.post('/api/admin/dyn-tube/account/create', {
      name,
      token,
      
      });
      return get.data;
    } catch (e) {
      return false;
    }
  };
  export const getDynAccount = async () => {
    try {
      const get: any = await instance.get('/api/admin/dyn-tube/account/get');
      return get.data;
    } catch (e) {
      return false;
    }
  };
  export const showDynAccount = async (id:string) => {
    try {
      const get: any = await instance.get('/api/admin/dyn-tube/account/get/'+id);
      return get.data;
    } catch (e) {
      return false;
    }
  };
  export const editDynAccount = async (id:string,name:string,token:string) => {
    try {
      const get: any = await instance.put('/api/admin/dyn-tube/account/edit/'+id,{
        name,
        token,
      });
      return get.data;
    } catch (e) {
      return false;
    }
  };
  export const deleteDynAccount = async (id:string) => {
    try {
      const get: any = await instance.delete('/api/admin/dyn-tube/account/delete/'+id);
      return get.data;
    } catch (e) {
      return false;
    }
  };
    export const setDefaultDynAccount = async(id:string,status:any)=>{
    try{
        const get: any = await instance.put(`/api/admin/dyn-tube/account/default/${id}`,{
            status:status,
        });
        return get.data;
     } catch (e) {
      return false;
    }
  }

  export const getDynCollections = async(page: number = 1)=>{
    try{
      const get: any = await instance.get(`/api/admin/dyn-tube/videos/collections?page=${page}`);
      return get.data;
    }catch(e){
        return false;
    }
  }
  export const getDynCollectionsSubDir = async(parentId:string, page: number = 1)=>{
    try{
      const get: any = await instance.get(`/api/admin/dyn-tube/videos/collections/${parentId}?page=${page}`);
      return get.data;
    }catch(e){
        return false;
    }
  }
   export const getDynCollectionsVideos = async(projectId:string)=>{
    try{
      const get: any = await instance.get(`/api/admin/dyn-tube/videos/collections/videos/${projectId}`);
      return get.data;
    }catch(e){
        return false;
    }
  }